const pricePlanTypes = {
  oneShot: 'one_shot',
  subscriptionWithTrial: 'subscription_with_trial',
  subscriptionWithoutTrial: 'subscription_without_trial',
}

export default pricePlanTypes